import { Component, OnInit } from '@angular/core';
import { EventSearchType } from '../../../models/_enum-collections';
import { HomeTabDetailsModel } from '../../advisor-incentives/advisor-incentives.component';
import { CommonSharedModule } from '../../common/shared.module';
import { MrppCountComponent } from '../mrpp-count/mrpp-count.component';
import { CustomerAcknowledgementComponent } from '../customer-acknowledgement/customer-acknowledgement.component';
import { EventReviewTableComponent } from '../../mcap-events/components/event-review-table/event-review-table.component';
import { PoeDocumentsComponent } from '../poe-documents/poe-documents.component';
import { CustomerSurveysComponent } from '../customer-surveys/customer-surveys.component';
import { AllEngagementsComponent } from '../all-engagements/all-engagements.component';

@Component({
  selector: 'app-mrpp-dashboard',
  templateUrl: './mrpp-dashboard.component.html',
  styleUrls: ['./mrpp-dashboard.component.scss'],
  standalone: true,
  imports: [
    CommonSharedModule,
    MrppCountComponent,
    CustomerAcknowledgementComponent,
    CustomerSurveysComponent,
    EventReviewTableComponent,
    PoeDocumentsComponent,
    AllEngagementsComponent
  ]
})
export class MrppDashboardComponent implements OnInit {
  tabList!: HomeTabDetailsModel[];

  ngOnInit() {
    this.tabList = [
      new HomeTabDetailsModel(true, true),
      new HomeTabDetailsModel(),
      new HomeTabDetailsModel(),
      new HomeTabDetailsModel(),
      new HomeTabDetailsModel(),
      new HomeTabDetailsModel()
    ];
  }

  get EventSearchType(): typeof EventSearchType {
    return EventSearchType;
  }

  onTabChange(event) {
    this.tabList.forEach(tab => {
      tab.isTabSelected = false;
      tab.hasTabLoaded = false;
    });
    this.tabList[event.index].hasTabLoaded = true;
    this.tabList[event.index].isTabSelected = true;
  }

  get isEngagementsCountSelected(): boolean {
    return this.tabList[0].isTabSelected;
  }
}
